export default __webpack_public_path__ + "src/images/packages/hillsneck-safari-lodge/36124ee71956f1bbb1b9eb3a9c69ab26-HillsNek Safari Camp_2.jpg";